const updates = [
  {
    time: '10分钟前',
    title: '《重生之都市修仙》第128话更新',
    tag: '国漫',
    desc: '陈凡突破金丹境，与天南第一剑仙展开巅峰对决，战斗场面燃爆全场。',
  },
  {
    time: '28分钟前',
    title: '《社长大人是恶魔》第56话上线',
    tag: '韩漫',
    desc: '办公室恋情迎来转折，社长终于坦白真实身份，女主陷入两难抉择。',
  },
  {
    time: '1小时前',
    title: '《咒术狂潮》第203话发布',
    tag: '日漫',
    desc: '最终决战篇开启，主角团集结完毕，史上最强反派正式登场。',
  },
  {
    time: '2小时前',
    title: '《穿越异世界成为药王》第89话连载',
    tag: '奇幻',
    desc: '主角研发新药成功，王国瘟疫危机得到控制，获得国王亲自嘉奖。',
  },
  {
    time: '3小时前',
    title: '《星河战神》第45话上线',
    tag: '国漫',
    desc: '机甲大战升级，主角驾驶新型战机迎战外星舰队，星际战争全面爆发。',
  },
  {
    time: '4小时前',
    title: '《王妃今天也在装柔弱》第112话更新',
    tag: '韩漫',
    desc: '宫斗剧情高能反转，王妃暗中布局震惊朝野，隐藏实力终于展露。',
  },
  {
    time: '5小时前',
    title: '《侦探少年团》第67话发布',
    tag: '日漫',
    desc: '新的案件更加离奇，少年侦探团深入调查废弃医院，真相逐渐浮出水面。',
  },
  {
    time: '6小时前',
    title: '《武林至尊》第301话连载',
    tag: '武侠',
    desc: '主角获得失传秘籍，闭关修炼突破瓶颈，武林大会一触即发。',
  },
  {
    time: '7小时前',
    title: '《甜蜜陷阱》第33话上线',
    tag: '恋爱',
    desc: '青梅竹马的重逢充满误会与心动，甜中带虐的剧情让人欲罢不能。',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            更新快讯
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            热门漫画实时更新，第一时间追到最新话
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-4 md:left-6 top-0 bottom-0 w-px bg-primary-200" />

          <div className="space-y-6 md:space-y-7">
            {updates.map((item, i) => (
              <div key={i} className="relative pl-10 md:pl-14">
                <div className="absolute left-2 md:left-3.5 top-1.5 w-3.5 h-3.5 md:w-4 md:h-4 rounded-full bg-primary-500 border-2 border-background-100" />

                <div className="flex flex-col sm:flex-row sm:items-center gap-1.5 sm:gap-3 mb-1.5">
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.time}</span>
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs font-medium rounded-full w-fit">
                    {item.tag}
                  </span>
                </div>

                <a
                  href="#cards"
                  onClick={(e) => {
                    e.preventDefault();
                    document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                  }}
                  className="text-base md:text-lg font-heading font-semibold text-foreground-900 hover:text-primary-600 transition-colors cursor-pointer"
                >
                  {item.title}
                </a>
                <p className="text-sm text-foreground-500 mt-1 leading-relaxed">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="text-center mt-10">
          <a
            href="#cards"
            onClick={(e) => {
              e.preventDefault();
              document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
            }}
            className="inline-flex items-center gap-2 px-6 py-3 text-primary-600 font-medium rounded-full hover:bg-primary-50 transition-colors cursor-pointer text-sm whitespace-nowrap"
          >
            查看更多更新
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}